<template>
  <div class="home" ref="scorrtop">
    <Header></Header>
    <!--轮播开始-->

    <div class="banner">
      <van-swipe :autoplay="5000" indicator-color="white">
        <van-swipe-item v-for="(item, index) in bannerData" :key="index">
          <img :src="item.showUrl" v-lazy="item.showUrl" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <!--轮播结束-->
    <!--招考信息开始-->
    <div class="zhaokao">
      <div class="name">
        <p>招考信息</p>
        <p>Recruitment Information</p>
      </div>
      <div class="more">
        <span @click="zhaokaoMore">更多</span>
        <span>
          <img src="../assets/home/mores.png" alt="" />
        </span>
      </div>
    </div>
    <!--招考信息结束-->
    <!--招考信息列表开始-->

    <div class="zhaolist">
      <div class="nav">
        <van-tabs
          v-model="active1"
          title-inactive-color="#666"
          title-active-color="#007CCF"
          background="#fafafa"
          swipeable
          animated
          :ellipsis="false"
        >
          <van-tab
            v-for="(item, index) in examData"
            :key="index"
            :title="item.moduleName"
            :name="index"
          >
            <div class="listSwiper">
              <div>
                <ul>
                  <li
                    v-for="(item, index) in item.articles"
                    :key="index"
                    @click="opendetail(item.id)"
                  >
                    <div class="listL">
                      <div v-if="item.synCalendar == 0">
                        <div class="icontype3">
                          <p>查看详情</p>
                        </div>
                      </div>
                      <div v-else>
                        <div
                          class="icontype1"
                          v-if="nowData < item.signUpTimeStart"
                        >
                          <p>即将报名</p>
                        </div>
                        <div
                          class="icontype1"
                          v-if="nowData > item.signUpTimeStart"
                        >
                          <p>报名截止</p>
                        </div>
                      </div>
                    </div>
                    <div class="listR">
                      <p>
                        <span>【{{ item.moduleName }}】</span
                        ><span>{{ item.title }}</span>
                      </p>
                      <p>{{ item.content.substring(0, 38) }}...</p>
                      <p>
                        <span>{{ item.siteName }}</span>
                        <span>{{ item.ctime | dateFormat }}</span>
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>

    <!--招考信息列表结束-->
    <!--日历开始-->
    <div class="calendarbox" v-if="CalendarDataLen != 0">
      <div class="calendar">
        <div style="height: 20px"></div>
        <div class="zhaokao">
          <div class="name">
            <p>考试日历</p>
            <p>Examination calendar</p>
          </div>
          <div class="more coursemore">
            <span><router-link to="/Calendarmore">更多</router-link></span>
            <span>
              <img src="../assets/home/mores.png" alt="" />
            </span>
          </div>
        </div>
        <!---->
        <div class="calendarList">
          <div class="calendarL" @click="onLeft()">
            <p><img src="../assets/home/back.png" alt="" /></p>
          </div>
          <div class="calendarCou">
            <div class="mian">
              <van-swipe :initial-swipe="calendarListindex">
                <van-swipe-item
                  style="height: 317px"
                  v-for="item in CalendarData"
                  :key="item.id"
                >
                  <div class="mianbg">
                    <p>倒计时</p>
                    <p>{{ item.datas }}天</p>
                  </div>
                  <div class="listdata">
                    <p>{{ item.title.substring(0, 10) }}</p>
                    <p>{{ item.signUpTimeStart | dateFormat }}</p>
                    <p>
                      <span>报名入口：</span
                      ><span><a :href="item.contentPart">点击进入</a></span>
                    </p>
                    <p @click="openCalendardetail(item.id)">详见公告→</p>
                  </div>
                </van-swipe-item>
              </van-swipe>
            </div>
          </div>
          <div class="calendaR" @click="onRight()">
            <p><img src="../assets/home/next.png" alt="" /></p>
          </div>
        </div>
        <!---->
      </div>
    </div>
    <!--日历结束-->
    <!--必考指导-->

    <div class="zhaokao">
      <div class="name">
        <p>必考指导</p>
        <p>Preparation for examination guidance</p>
      </div>
      <div class="more coursemore">
        <span><router-link to="/bikaoMore">更多</router-link></span>
        <span>
          <img src="../assets/home/mores.png" alt="" />
        </span>
      </div>
    </div>
    <div class="zhaolist">
      <div class="nav">
        <van-tabs
          v-model="active2"
          title-inactive-color="#666"
          title-active-color="#007CCF"
          background="#fafafa"
          swipeable
          animated
        >
          <van-tab
            v-for="(item, index) in guideData"
            :key="index"
            :title="item.moduleName"
            :name="index"
          >
            <div class="zhidao">
              <div class="listSwiper">
                <ul>
                  <li
                    v-for="(item, index) in item.articles"
                    :key="index"
                    @click="openguide(item.id)"
                  >
                    <div>
                      <span>【{{ item.moduleName }}】</span>
                      <span>{{ item.title }}</span>
                    </div>
                    <div>
                      <p>{{ item.content.substring(0, 50) }}...</p>
                    </div>
                    <div>
                      <span>{{ item.siteName }}</span>
                      <span>{{ item.ctime | dateFormat }}</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
      <!-- <div class="zhidao">
				<div class="listSwiper">
					<van-swipe :show-indicators='indicators' :initial-swipe='index2' @change="swipernextZn">
						<van-swipe-item>
							<ul>
								<li v-for="item in 6">
									<div>
										<span>【技巧巩固】</span>
										<span>2019年曲靖一中景洪学校招聘公告</span>
									</div>
									<div>
										<p>曲靖一中景洪学校位于西双版纳于西双版版纳，曲靖一中景洪学校位于...</p>
									</div>
									<div>
										<span>曲靖</span>
										<span>2020-01-02</span>
									</div>
								</li>

							</ul>
						</van-swipe-item>
						<van-swipe-item>
							报考指南
						</van-swipe-item>
					</van-swipe>
				</div>
			</div> -->
    </div>
    <!--必考指导结束-->
    <!--资料下载-->
    <!-- <div class="minas">
			<div class="calendar">
				<div style="height:20px;"></div>
				<div class="zhaokao">
					<div class="name">
						<p style="color: #fff;">资料下载</p>
						<p>Data download</p>
					</div>
					<div class="more dowmore">
						<span style="color: #fff;"><router-link to='/Dowmore'>更多</router-link></span>
						<span>
							<img src="../assets/home/mores.png" alt="">
						</span>
					</div>
				</div>
			
				<div class="calendarList">
					<div class="calendarL">
						<p style="margin-top: 128px;"><img src="../assets/lff.png" alt=""></p>
					</div>
					<div class="calendarCou">
						<div class="mian main1">
							<van-swipe>
								<van-swipe-item>
									<p class="dowp1"><img src="../assets/home/ziliao.png" alt=""></p>
									<p class="dowp2">2019年</p>
									<p class="dowp3">特岗真题语文</p>
									<p class="dowp4"><span></span></p>
									<p class="dowp5">↓</p>
								</van-swipe-item>
								<van-swipe-item>
									<p class="dowp1"><img src="../assets/home/ziliao.png" alt=""></p>
									<p class="dowp2">2020年</p>
									<p class="dowp3">asdsadqwe</p>
									<p class="dowp4"><span></span></p>
									<p class="dowp5">↓</p>
								</van-swipe-item>
							</van-swipe>
						</div>
					</div>
					<div class="calendaR">
						<p style="margin-top: 128px;"><img src="../assets/rfff.png" alt=""></p>
					</div>
				</div>
			
			</div>
		</div> -->
    <!--资料下载完-->
    <!--热门网课开始-->
    <!-- <div class="hotcourse">
			<div class="zhaokao">
				<div class="name">
					<p>热门网课</p>
					<p>Popular courses</p>
				</div>
				<div class="more coursemore">
					<span><router-link to='/CourseMore'>更多</router-link></span>
					<span>
						<img src="../assets/home/mores.png" alt="">
					</span>
				</div>
			</div>
		
			<div class="zhaolist">
				<div class="nav">
					<van-tabs v-model="active3" title-inactive-color='#666' title-active-color='#007CCF' background="#fafafa"
					 swipeable animated>
						<van-tab title="教师招聘" name='0'></van-tab>
						<van-tab title="教师资格证" name='1'></van-tab>
						<van-tab title="特岗教师" name='2'></van-tab>
						<van-tab title="事业单位D类" name='3'></van-tab>

					</van-tabs>
				</div>
				<div class="listSwiper">
					<van-swipe :show-indicators='indicators' :initial-swipe='index3'>
						<van-swipe-item>
							<div class="hotmain">
								<div class="hotmainbox" v-for="item in 4" :key=''>
									<div class="horimg">
										<img height="91px" src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1578748028343&di=2b49a4ffaeea38cab2490fd644f7faa4&imgtype=0&src=http%3A%2F%2Fn.sinaimg.cn%2Fsinacn20117%2F0%2Fw1024h576%2F20190905%2F34e4-ieftthx3876424.jpg"
										 alt="">
									</div>
									<div class="hottit">
										<p>2019年（下）国考教师资格证-考前…</p>
									</div>
									<div class="hotinfo">
										<span>查看详情</span><span><img src="../assets/home/lannest.png" alt=""></span>
									</div>
								</div>

							</div>
						</van-swipe-item>
						<van-swipe-item>
							<div class="hotmain">
								<div class="hotmainbox" v-for="item in 4" :key=''>
									<div class="horimg">
										<img height="91px" src="https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=20500450,2038027975&fm=26&gp=0.jpg"
										 alt="">
									</div>
									<div class="hottit">
										<p>2019年玩儿的身份sd考前…</p>
									</div>
									<div class="hotinfo">
										<span>查看详情</span><span><img src="../assets/home/lannest.png" alt=""></span>
									</div>
								</div>
							</div>
						</van-swipe-item>
						<van-swipe-item>
							特岗教师 3
						</van-swipe-item>
						<van-swipe-item>
							事业单位D类4
						</van-swipe-item>

					</van-swipe>
				</div>
			</div>
			
		</div> -->
    <!--热门网课结束-->
    <div style="height: 400px" class="teacherList">
      <div class="calendar">
        <div style="height: 20px"></div>
        <div class="zhaokao">
          <div class="name">
            <p>云师名师</p>
            <p>Master of YUNSHI</p>
          </div>
          <div class="more teachermore">
            <span><router-link to="/Teachermore">更多</router-link></span>
            <span>
              <img src="../assets/home/mores.png" alt="" />
            </span>
          </div>
        </div>
        <!---->
        <div class="calendarList">
          <div class="calendarL">
            <p @click="onLeftTeacher" style="margin-top: 90px">
              <img src="../assets/home/back.png" alt="" />
            </p>
          </div>
          <div class="calendarCou">
            <div class="mian calendarListbox" style="height: 270px">
              <van-swipe :initial-swipe="teacherIndex">
                <van-swipe-item
                  style="height: 290px"
                  v-for="(item, index) in teacherData"
                  :key="index"
                  @click="openteacher(item.id)"
                >
                  <div class="teaherbg">
                    <img :src="item.cover" :alt="item.name" />
                  </div>
                  <div class="teacherp">
                    <p>{{ item.name }}</p>
                    <p>{{ item.title }}</p>
                    <p></p>
                    <p>{{ item.description.substring(0, 45) }}...</p>
                  </div>
                </van-swipe-item>
              </van-swipe>
            </div>
          </div>
          <div class="calendaR">
            <p @click="onRightTeacher" style="margin-top: 90px">
              <img src="../assets/home/next.png" alt="" />
            </p>
          </div>
        </div>
        <!---->
      </div>
    </div>
    <!--
     	作者：offline
     	时间：2020-01-12
     	描述：
     
		<div class="wenda">
			<div class="zhaokao">
				<div class="name">
					<p>云师问答</p>
					<p>YUNSHI Q & A</p>
				</div>
				<div class="more wendamore">
					<span><router-link to='/Quesrionmore'>更多</router-link></span>
					<span>
						<img src="../assets/home/mores.png" alt="">
					</span>
				</div>
			</div>
			<div class="wendalist">
				<ul>
					<li v-for="(item,index) in 4" :key='index' @click="anwiserDeatil()">
						<div class="wendatop">
							<p>报考教师需要普通话证书吗？普通话什么等级才能当老师？</p>
						</div>
						<div class="bottombox">

							<div class="boyya">
								<span><img width="16.5px" height="16.5px" src="../assets/home/bg4.png" /></span>
								<span>健康sad</span>
								<span>2012-12-12</span>
							</div>
							<div class="boyyb">
								<span><img width="18px" height="16px" src="../assets/home/num.png" /></span>
								<span>10</span>
							</div>
						</div>
					</li>

				</ul>
			</div>
		</div>
		<!--去提问按钮-->
    <!--<div class="tibtn">
			<p @click="goAnwiser()"><span>去提问</span><span><img src="../assets/home/next1.png" alt=""></span></p>
		</div>
		-->
    <!--咨询开始-->
    <div class="zixun" v-if="advisoryData.length != 0">
      <div class="zhaokao">
        <div class="name">
          <p>云师资讯</p>
          <p>YUNSHI information</p>
        </div>
        <div class="more wendamore">
          <span><router-link to="/Zixunmore">更多</router-link></span>
          <span>
            <img src="../assets/home/mores.png" alt="" />
          </span>
        </div>
      </div>
      <div class="zixunbox">
        <div class="zibg">
          <img :src="advisoryData[0].cover" alt="" height="138px" />
        </div>
        <div class="ziinfo">
          <p>{{ advisoryData[0].title }}</p>
          <p>{{ advisoryData[0].contentPart.substring(0, 80) }}...</p>
          <p>
            <span>{{ advisoryData[0].ctime | dateFormat }}</span
            ><span @click="yszixun(advisoryData[0].id)">查看详情</span>
            <span style="margin-right: 13px">
              <img
                src="../assets/home/lannest.png"
                alt=""
                style="margin-top: 13px"
              />
            </span>
          </p>
          <p style="height: 10px"></p>
        </div>
      </div>
    </div>
    <!--咨询结束-->
    <Fotter></Fotter>
    <!--弹出区域层-->
    <div class="bottombtn" v-if="botfix">
      <div class="botbox">
        <p>
          <a href="tel:400-996-2596"
            ><img src="../assets/home/tel.png" alt=""
          /></a>
        </p>
        <p>
          <router-link to="/Dowload"
            ><img src="../assets/home/xiazai.png" alt=""
          /></router-link>
        </p>
        <p @click="backTop()"><img src="../assets/home/top.png" alt="" /></p>
      </div>
    </div>
    <!-- </van-popup> -->
  </div>
</template>

<script>
import Header from "./Header.vue";
import Fotter from "./Fotter.vue";
import __Config from "../api/config";

export default {
  name: "home",
  components: {
    Fotter,
    Header,
  },
  data() {
    return {
      active1: "0", //招聘信息
      active2: "0", //备考指南
      active3: "0", //热门网课
      index1: 0, //招聘信息轮播默认下标

      index3: 0, //
      indicators: false, //不显示下标圆点
      touchable: false,
      show: false, //弹出区域层
      botfix: false, //滚动大于600显示
      //
      calendarListindex: 0, //日历默认下标
      teacherIndex: 0,
      nowData: new Date().getTime(),
      siteId: this.$store.state.treeData.id, //站点ID
      siteCode: this.$store.state.treeData.code,
      bannerData: [], //轮播图
      examData: [], //招聘考勤
      CalendarData: [], //日历
      CalendarDataLen: null,
      guideData: [], //必考指南
      teacherData: [], //老师
      teacherDatalen: null,
      advisoryData: [], //资讯
    };
  },
  computed: {
    isFollow() {
      return this.$store.state.treeData.id; //需要监听的数据
    },
  },
  watch: {
    isFollow(newVal, oldVal) {
      // console.log(newVal);
      // console.log(this.$store.state.treeData.code)
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: "加载中...",
      });
      this.getRl(); //刷新日历
      this.getguides(); //必考指南
      this.getadvisorys(); //资讯
      this.getinfioo();
    },
  },
  methods: {
    getinfioo() {
      var that = this;
      this.$axios
        .get(__Config.api.getexam, {
          params: {
            siteCode: this.$store.state.treeData.code,
            siteId: this.$store.state.treeData.id,
          },
        })
        .then(function (res) {
          that.examData = res.data.data[0].children;
          let moduleId = res.data.data[0].moduleId;
          //数据
          //  that.$store.commit('examDatas',res.data.data[0].children);
          //去获取模块信息
          that.getmoduleCode(moduleId);
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    getmoduleCode(id) {
      //
      //储存 招聘信息模块id
      var that = this;
      this.$axios
        .get(__Config.api.getmodule, {
          params: {
            moduleId: id,
          },
        })
        .then(function (res) {
          // console.log(res.data.data.code)
          // console.log(res.data.data.id)
          let obj = {
            moduleId: res.data.data.id,
            moduleCode: res.data.data.code,
          };
          that.$store.commit("moduleIdfn", obj);
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    //轮播图
    getBanner: function () {
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: "加载中...",
      });
      var that = this;
      this.$axios
        .get(__Config.api.bannerlist, {
          params: {
            position: 1,
            size: 5,
            siteId: this.siteId,
          },
        })
        .then(function (res) {
          that.$toast.clear();
          that.bannerData = res.data.data;
        })
        .catch(function (err) {
          that.$toast.clear();
          console.log(err);
        });
    },

    //招考信息详情
    opendetail(id) {
      // localStorage.setItem("Zhaokaoid",id);
      this.$router.push({
        path: "/ZhaokaoMoreDetail",
        name: "ZhaokaoMoreDetail",
        query: {
          id: id,
        },
      });
    },

    //考试日列
    getRl() {
      var that = this;
      this.$axios
        .get(__Config.api.gethomeExamCalendar, {
          params: {
            siteCode: this.$store.state.treeData.code,
            siteId: this.$store.state.treeData.id,
          },
        })
        .then(function (res) {
          that.CalendarData = res.data.data;
          that.CalendarDataLen = res.data.data.length;
          for (var i = 0; i < res.data.data.length; i++) {
            var bettenTime =
              res.data.data[i].signUpTimeStart - new Date().valueOf();
            var datavtn = parseInt(bettenTime / (1000 * 60 * 60 * 24));
            if (datavtn < 0) {
              res.data.data[i].datas = 0;
            } else {
              res.data.data[i].datas = parseInt(
                bettenTime / (1000 * 60 * 60 * 24)
              );
            }
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    //左边点击
    onLeft() {
      if (this.calendarListindex > 0) {
        this.calendarListindex--;
        if (this.calendarListindex == 0) {
          this.calendarListindex = 0;
          console.log(this.calendarListindex);
        }
      } else {
        this.calendarListindex = this.CalendarDataLen;
        this.calendarListindex--;
      }
    },
    //右边点击
    onRight() {
      if (this.calendarListindex < this.CalendarDataLen) {
        this.calendarListindex++;

        if (this.calendarListindex == this.CalendarDataLen) {
          this.calendarListindex = 0;
        }
      } else {
        console.log(this.calendarListindex);
        this.calendarListindex = 0;
      }
    },
    //考试日列详情
    openCalendardetail(id) {
      localStorage.setItem("Calendarid", id);
      this.$router.push({
        name: "Calendar_detail",
      });
    },
    //必考指南
    getguides() {
      var that = this;
      this.$axios
        .get(__Config.api.getguide, {
          params: {
            siteCode: this.$store.state.treeData.code,
            siteId: this.$store.state.treeData.id,
          },
        })
        .then(function (res) {
          that.$toast.clear();
          that.guideData = res.data.data[0].children;
          //  console.log(res.data.data);
          let moduleId = res.data.data[0].moduleId;
          that.getguidesIDandCode(moduleId);
        })
        .catch(function (err) {
          that.$toast.clear();
          console.log(err);
        });
    },

    //获取必考指南模块ID 模块code
    getguidesIDandCode(id) {
      //储存 招聘信息模块id
      var that = this;
      this.$axios
        .get(__Config.api.getmodule, {
          params: {
            moduleId: id,
          },
        })
        .then(function (res) {
          let obj = {
            moduleId: res.data.data.id,
            moduleCode: res.data.data.code,
          };
          that.$store.commit("bikaoIds", obj);
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    //必考指南详情
    openguide(id) {
      //localStorage.setItem("Zhaokaoid",id);
      this.$router.push({
        path: "/ZhaokaoMoreDetail",
        // name:"ZhaokaoMoreDetail" ,
        query: {
          id: id,
        },
      });
    },

    //老师列表
    getwebTeachers() {
      var that = this;
      this.$axios
        .get(__Config.api.getwebTeacher, {
          params: {
            pageNo: 1,
            pageSize: 5,
          },
        })
        .then(function (res) {
          that.teacherData = res.data.data;
          that.teacherDataLen = res.data.data.length;
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    //左边点击
    onLeftTeacher() {
      if (this.teacherIndex > 0) {
        this.teacherIndex--;
        if (this.teacherIndex == 0) {
          this.teacherIndex = 0;
        }
      } else {
        this.teacherIndex = this.teacherDataLen;
        this.teacherIndex--;
      }
    },
    //右边点击
    onRightTeacher() {
      if (this.teacherIndex < this.teacherDataLen) {
        this.teacherIndex++;
        if (this.teacherIndex == this.teacherDataLen) {
          this.teacherIndex = 0;
        }
      } else {
        console.log(this.teacherIndex);
        this.teacherIndex = 0;
      }
    },
    //老师详情
    openteacher(id) {
      this.$router.push({
        name: "TeacherDetail",
        params: {
          id: id,
        },
      });
    },
    //资讯
    getadvisorys() {
      var that = this;
      this.$axios
        .get(__Config.api.getadvisory, {
          params: {
            siteCode: this.$store.state.treeData.code,
            siteId: this.$store.state.treeData.id,
          },
        })
        .then(function (res) {
          that.$toast.clear();
          that.advisoryData = res.data.data[0].articles;
          that.$store.commit("advisoryfn", res.data.data[0].articles);
          // console.log(res.data.data[0].articles);
        })
        .catch(function (err) {
          that.$toast.clear();
          console.log(err);
        });
    },

    //招考更多
    zhaokaoMore() {
      this.$router.push({
        path: "/ZhaokaoMore",
        name: "",
        params: {
          key: "key",
        },
      });
    },
    //云师咨询
    yszixun(id) {
      this.$router.push({
        path: "/ZixunDetail",
        query: {
          id: id,
        },
      });
    },

    //去提问
    // goAnwiser(){
    // 		this.$router.push({
    // 		path: './Quesrionmore',
    // 		name: '',
    // 		params: {
    // 			key: 'key',
    // 		}

    // 	})
    // },
    //提问详情
    // anwiserDeatil(){
    // 	this.$router.push({
    // 		path: './Quesrionmore_detail',
    // 		name: '',
    // 		params: {
    // 			key: 'key',
    // 		}

    // 	})
    // },

    //页面滚动大于600显示
    Roll() {
      if (
        !!document.documentElement.scrollTop &&
        document.documentElement.scrollTop > 600
      ) {
        this.botfix = true;
      } else {
        this.botfix = false;
      }
    },
    //回到顶部
    backTop() {},
  },
  created() {
    this.getwebTeachers(); //老师
    this.getadvisorys(); //资讯
  },

  mounted: function () {
    this.getRl(); //日历
    this.getBanner(); //轮播
    this.getguides(); //必考
    this.getinfioo();

    window.addEventListener("scroll", this.Roll);
  },
  destroyed() {
    //组件销毁的时候移除事件
    window.removeEventListener("scroll", this.Roll);
  },
};
</script>
<style scoped>
/* .swiper-button-prev, .swiper-container-rtl .swiper-button-next{
	background-image:url("../assets/home/back.png");
	width: 12px;
	height:23px;
	background-size: cover;
	left: 10px;
} */
.swiper-container {
  width: 100%;
  height: 300px;
}
/*轮播*/
.banner {
  width: 92%;
  height: 158px;
  background: #f4f4f4;
  box-shadow: 0px 2px 5px rgba(0, 124, 216, 0.16);
  margin: 0 auto;
  margin-top: 4px;
  border-radius: 12px;
  overflow: hidden;
}

.banner .van-swipe {
  height: 100%;
  width: 100%;
}

.banner .van-swipe-item {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
.banner .van-swipe img {
  width: 100%;
  height: 100%;
}

.banner .van-swipe-item:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 3px;
  background-color: rgba(255, 255, 255, 0.075);
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  -webkit-animation: blink 4s ease-in 6s infinite;
  animation: blink 4s ease-in 6s infinite;
}
@-webkit-keyframes blink {
  from {
    left: 10px;
    top: 0;
  }
  to {
    left: 320px;
    top: 0;
  }
}
@-o-keyframes blink {
  from {
    left: 10px;
    top: 0;
  }
  to {
    left: 320px;
    top: 0;
  }
}
@-moz-keyframes blink {
  from {
    left: 10px;
    top: 0;
  }
  to {
    left: 320px;
    top: 0;
  }
}
@keyframes blink {
  from {
    left: -100px;
    top: 0;
  }
  to {
    left: 320px;
    top: 0;
  }
}

/*招考*/
.zhaokao {
  width: 95%;
  height: 40px;

  margin: 20px auto;
  display: flex;
}

.name {
  flex: 1;
}

.name p:nth-child(1) {
  font-size: 15px;
  color: #333;
  font-weight: bold;
}

.name p:nth-child(2) {
  font-size: 10px;
  color: #ccc;
  margin-top: 5px;
}

.more {
  width: 50px;
  height: 40px;
  line-height: 40px;
  color: #999;
  font-size: 12px;
}
.wendamore a {
  color: #999;
}
.dowmore a {
  color: #fff;
}
.teachermore a {
  color: #999;
}
.coursemore a {
  color: #999;
}
.more span:nth-child(2) {
  width: 10.5px;
  height: 10px;
  margin-left: 5px;
}

.more span:nth-child(2) img {
  width: 10.5px;
  height: 10px;
}

/*招聘信息列表*/
.van-tabs__line {
  background-color: #007ccf !important;
}
.listSwiper {
  width: 95%;
  margin: 20px auto;
}
/* */
.listSwiper ul li {
  width: 99%;
  height: 80px;
  background: #fff;
  margin-top: 8px;
  box-shadow: 0px 2px 5px rgba(0, 124, 216, 0.16);
  border-radius: 7px;
  display: flex;
}
.listSwiper ul li .listL {
  width: 80px;
  height: 100%;
}
.listL .icontype1 {
  width: 55px;
  height: 55px;
  border: 1px solid rgba(0, 124, 207, 1);
  border-radius: 5px;
  margin: 10px 10px;
}
.listL .icontype1 p {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 26px;
  color: rgba(0, 124, 207, 1);
  text-align: center;
}
.icontype2 {
  width: 55px;
  height: 55px;
  border: 1px solid #ffbb00;
  border-radius: 5px;
  margin: 10px 10px;
}
.listL .icontype2 p {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 26px;
  color: #ffbb00;
  text-align: center;
}
.icontype3 {
  width: 55px;
  height: 55px;
  border: 1px solid #7d00cf;
  border-radius: 5px;
  margin: 10px 10px;
}

.listL .icontype3 p {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 26px;
  color: #7d00cf;
  text-align: center;
}
.listSwiper ul li .listR {
  flex: 1;
  height: 100%;
  margin-left: 20px;
}
.listR p:nth-child(1) {
  height: 18px;
  overflow: hidden;
  margin-top: 2px;
  width: 98%;
}
.listR p:nth-child(1) span:nth-child(1) {
  color: #007ccf;
  font-size: 12px;
  font-weight: 600;
  margin-left: -6px;
}
.listR p:nth-child(1) span:nth-child(2) {
  color: #333;
  font-size: 12px;
  font-weight: 600;
}
.listR p:nth-child(2) {
  height: 34px;
  overflow: hidden;
  font-size: 10px;
  font-weight: 300;
  margin-top: 5px;
  width: 98%;
  color: #666;
}
.listR p:nth-child(3) {
  height: 15px;
  overflow: hidden;
  font-size: 10px;
  font-weight: 300;
  margin-top: 2px;
}
.listR p:nth-child(3) span:nth-child(1) {
  font-size: 10px;
  font-weight: 600;
  line-height: 14px;
  color: rgba(0, 124, 207, 1);
}
.listR p:nth-child(3) span:nth-child(2) {
  float: right;
  margin-right: 10px;
  color: #666666;
}
.calendarbox .calendar {
  width: 100%;
  height: 440px;
  /* background: url('../assets/home/bg1.png'); */
  background-image: linear-gradient(#f1f1e7, #ffe7c5, #dfbba7);
  background-size: cover;
  overflow: hidden;
}
/**/
.calendarList {
  display: flex;
  height: 100%;
}
.calendarL {
  width: 40px;
  height: 100%;
  margin-left: 13px;
}
.calendarL p {
  margin-top: 150px;
  margin-left: 10px;
  cursor: pointer;
}
.calendaR {
  width: 40px;
  height: 100%;
  margin-right: 13px;
}
.calendaR p {
  margin-top: 150px;
  margin-left: 17px;
  cursor: pointer;
}
.calendarCou {
  flex: 1;
  height: 100%;
}
.mian {
  width: 201px;
  height: 295px;
  background: rgba(255, 255, 255, 1);
  border-radius: 7px;
  margin: 0 auto;
  overflow: hidden;
}
.mianbg {
  width: 73px;
  height: 71px;
  background: url("../assets/home/rili.png");
  position: absolute;
  top: 10px;
  left: 64px;
}
.mianbg p:nth-child(1) {
  font-size: 7px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 9px;
  color: rgba(0, 124, 207, 1);
  position: absolute;
  top: 35px;
  left: 30px;
}
.mianbg p:nth-child(2) {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 9px;
  color: rgba(0, 124, 207, 1);
  position: absolute;
  top: 51px;
  left: 26px;
}

.listdata {
  width: 100%;
  height: 180px;
  position: absolute;
  top: 100px;
  overflow: hidden;
  text-align: center;
}

.listdata p:nth-child(1) {
  font-size: 15px;
  font-weight: 600;
  line-height: 30px;
  color: rgba(51, 51, 51, 1);
  opacity: 1;
}

.listdata p:nth-child(2) {
  font-size: 13px;
  font-weight: 600;
  line-height: 30px;
  color: rgba(0, 124, 207, 1);
}

.listdata p:nth-child(3) span:nth-child(1) {
  font-size: 12px;
  font-weight: 300;
  line-height: 30px;
  color: #666666;
}

.listdata p:nth-child(3) span:nth-child(2) {
  font-size: 12px;
  font-weight: 300;
  line-height: 30px;
  color: rgba(0, 124, 207, 1);
}

.listdata p:nth-child(4) span:nth-child(1) {
  font-size: 12px;
  font-weight: 300;
  line-height: 25px;
  color: #666666;
}

.listdata p:nth-child(4) span:nth-child(2) {
  font-size: 12px;
  font-weight: 300;
  line-height: 25px;
  color: rgba(0, 124, 207, 1);
}

.listdata p:nth-child(4) {
  width: 171px;
  height: 33px;
  background: rgba(0, 124, 207, 1);
  opacity: 1;
  border-radius: 17px;
  margin-left: 15px;
  margin-top: 20px;
  color: #fff;
  line-height: 33px;
}

.zhidao ul li {
  width: 99%;
  height: 101px;
  background: #fff;
  margin-top: 8px;
  -webkit-box-shadow: 0px 2px 5px rgba(0, 124, 216, 0.16);
  box-shadow: 0px 2px 5px rgba(0, 124, 216, 0.16);
  border-radius: 7px;
  flex-flow: column;
  overflow: hidden;
}

.zhidao ul li div:nth-child(1) {
  height: 20px;
  overflow: hidden;
  margin: 10px;
}

.zhidao ul li div:nth-child(1) span:nth-child(1) {
  color: #007ccf;
  font-size: 12px;
  font-weight: 600;
  margin-left: -6px;
}

.zhidao ul li div:nth-child(1) span:nth-child(2) {
  color: #333;
  font-size: 12px;
  font-weight: 600;
}

.zhidao ul li div:nth-child(2) {
  overflow: hidden;
  font-size: 10px;
  font-weight: 300;
  width: 95%;
  color: #666;
  margin-left: 10px;
}

.zhidao ul li div:nth-child(3) {
  height: 20px;
  margin-top: 4px;
  margin-left: 10px;
  font-size: 12px;
}

.zhidao ul li div:nth-child(3) span:nth-child(1) {
  font-size: 10px;
  font-weight: 600;
  line-height: 14px;
  color: rgba(0, 124, 207, 1);
}

.zhidao ul li div:nth-child(3) span:nth-child(2) {
  float: right;
  margin-right: 10px;
  color: #666666;
}

/*资料下载*/

.main1 .van-swipe {
  width: 100%;
  height: 100%;
}

.minas {
  /* background: url("../assets/home/bg2.png"); */
  background-image: linear-gradient(#001f34, #608097, #072337);
  background-size: cover;
  height: 368px;
  overflow: hidden;
}

.main1 {
  background: transparent;
}

.dowp1 {
  width: 27px;
  height: 34px;
  margin-left: 84px;
  margin-top: 28px;
}

.dowp2 {
  text-align: center;
  font-size: 17px;
  font-weight: 600;
  line-height: 24px;
  color: #fff;
  margin-top: 20px;
}

.dowp3 {
  text-align: center;
  font-size: 17px;
  font-weight: 600;
  line-height: 24px;
  color: #fff;
  margin-top: 20px;
}

.dowp4 {
  width: 100%;
  height: 50px;
}

.dowp4 span {
  width: 20px;
  height: 1px;
  background: #ccc;
  display: block;
  margin-left: 91px;
  margin-top: 12px;
}

.dowp5 {
  font-size: 17px;
  font-weight: 600;
  color: #fff;
  margin-top: -25px;
  text-align: center;
}

/**热门课程**/

/*老师*/
.teacherList {
  /* background: url(../assets/home/bg3.png); */
  background-image: linear-gradient(#9b876f, #fcfed4, #2d271b);
  background-size: cover;
  overflow: hidden;
}

.calendarListbox .teaherbg {
  width: 100%;
  height: 143px;
}

.calendarListbox .teaherbg img {
  width: 100%;
  height: 100%;
}

.teacherp p:nth-child(1) {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  margin: 10px 0px 0px 10px;
}

.teacherp p:nth-child(2) {
  font-size: 12px;
  font-weight: 400;
  height: 20px;
  width: 90%;
  color: rgba(153, 153, 153, 1);
  margin: 10px 0px 0px 10px;
  overflow: hidden;
}

.teacherp p:nth-child(3) {
  width: 90%;
  height: 2px;
  background: #ccc;
  margin-left: 10px;
  margin-top: 10px;
}

.teacherp p:nth-child(4) {
  width: 90%;
  height: 42px;
  font-size: 10px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 13px;
  color: rgba(153, 153, 153, 1);
  margin: 10px 0px 0px 10px;
}

/*问答*/

/*提问*/
.tibtn {
  width: 95%;
  height: 40px;
  background: rgba(0, 124, 207, 1);
  opacity: 1;
  border-radius: 20px;
  margin: 20px auto 58px auto;
  text-align: center;
  line-height: 40px;
  color: #fff;
}
.tibtn p span:nth-child(2) {
  margin-left: 10px;
}
.zixunbox {
  width: 95%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 5px rgba(0, 124, 216, 0.16);
  margin: 0 auto 30px auto;
}
.zibg {
  width: 100%;
  height: 138px;
}
.zibg img {
  width: 100%;
  height: 138px;
}
.ziinfo p:nth-child(1) {
  font-size: 15px;
  font-weight: bold;
  line-height: 21px;
  color: #333;
  margin: 13px 0px 0px 13px;
}
.ziinfo p:nth-child(2) {
  font-size: 10px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 13px;
  color: rgba(153, 153, 153, 1);
  margin: 13px 0px 0px 13px;
  width: 95%;
  line-height: 21px;
}
.ziinfo p:nth-child(3) {
  display: flex;
}
.ziinfo p:nth-child(3) span:nth-child(1) {
  flex: 1;
  font-size: 10px;
  font-weight: 100;
  line-height: 14px;
  color: rgba(153, 153, 153, 1);
  margin-left: 13px;
  margin-top: 10px;
}
.ziinfo p:nth-child(3) span:nth-child(2) {
  font-size: 12px;
  font-family: .PingFang SC;
  font-weight: 500;
  line-height: 15px;
  color: rgba(0, 124, 207, 1);
  margin-right: 13px;
  margin-top: 10px;
}
/*区域层*/
.bottombtn {
  width: 100%;
  height: 40px;
  border-radius: 22px;
  display: flex;
  z-index: 999;
  opacity: 0.8;
  position: fixed;
  bottom: 4px;
}

.botbox {
  width: 95%;
  height: 100%;
  margin: 0 auto;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 22px;
  display: flex;
}

.bottombtn .botbox p {
  flex: 1;
  text-align: center;
  line-height: 40px;
  color: #fff;
  position: relative;
}

.bottombtn .botbox p img {
  text-align: center;
  display: block;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  margin: auto;
}

.bottombtn .botbox p:nth-child(1) {
  border-right: 2px solid #fff;
}

.bottombtn .botbox p:nth-child(2) {
  border-right: 2px solid #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue